import { useState, useEffect, ChangeEvent } from "react";
import { useSelector } from "react-redux";
import axios from "axios";
import { RootState } from "../store/indexRedux";
import { Partner, PartnerContact } from "../types/addServiceTypes";

export const usePartnerData = () => {
  const [selectedPartnerLocal, setSelectedPartnerLocal] = useState<Partner | null>(null);
  const [partnerContacts, setPartnerContacts] = useState<PartnerContact[]>([]);
  const [selectedPartnerContact, setSelectedPartnerContact] = useState<PartnerContact | null>(null);

  const user = useSelector((state: RootState) => state.user);
  const partners = useSelector((state: RootState) => state.partner.partners);
  const accessToken = useSelector((state: RootState) => state.authv2.accessToken);

  console.log("Selected Partner Local:", selectedPartnerLocal);
  console.log("Partner Contacts:", selectedPartnerContact);

  // Helper function to fetch partner contacts
  const fetchPartnerContacts = async (partnerId: number) => {
    if (!accessToken) return;
    try {
      const response = await axios.get(`${import.meta.env.VITE_AUTH_BASE_URL}/api/v1/partners/${partnerId}`, {
        headers: { Authorization: `Bearer ${accessToken}` },
      });
      const contacts = response.data.data.contacts || [];
      setPartnerContacts(contacts);

      // Don't auto-select any contact - let user choose manually
      setSelectedPartnerContact(null);
    } catch (error) {
      console.error("Error fetching partner contacts:", error);
    }
  };

  useEffect(() => {
    // Only auto-select for partner role users (they see their own partner)
    if (partners?.length > 0 && user?.user?.role === "partner") {
      const partnerToSelect = partners.find((p) => p.id === user?.user?.id) || null;

      if (partnerToSelect) {
        console.log("Auto-selecting partner for partner role:", partnerToSelect);
        setSelectedPartnerLocal(partnerToSelect);
        fetchPartnerContacts(partnerToSelect.id);
      }
    }
    // For admin and regular users, don't auto-select anything
  }, [user, partners]);

  const handlePartnerChange = async (e: ChangeEvent<HTMLSelectElement>) => {
    const partnerId = Number(e.target.value);
    const foundPartner = partners.find((p) => p.id === partnerId) || null;
    setSelectedPartnerLocal(foundPartner);
    setSelectedPartnerContact(null); // Reset selected contact

    if (partnerId) {
      await fetchPartnerContacts(partnerId);
    } else {
      setPartnerContacts([]);
    }
  };

  const handlePartnerContactChange = (e: ChangeEvent<HTMLSelectElement>) => {
    const contactId = Number(e.target.value);
    const foundContact = partnerContacts.find((c) => c.id === contactId) || null;
    setSelectedPartnerContact(foundContact);
  };

  return {
    selectedPartnerLocal,
    partnerContacts,
    selectedPartnerContact,
    // isAdminOrPartner: user?.user?.role === "admin" || user?.user?.role === "partner",
    isAdminOrPartner: false, // Force client view for everyone (for testing)
    handlePartnerChange,
    handlePartnerContactChange,
    partners,
    user,
  };
};
